// extracted by mini-css-extract-plugin
export default {"group":"EventCoE_group__Vt7fl"};